var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutubeMobileShortSound = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 20,
  viewBox: "0 0 18 20",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M9 0v11.725A5.16 5.16 0 0 0 5.143 10C2.3 10 0 12.238 0 15s2.301 5 5.143 5 5.143-2.238 5.143-5V5H18V0zM5.143 18.75c-2.134 0-3.857-1.675-3.857-3.75s1.723-3.75 3.857-3.75S9 12.925 9 15s-1.723 3.75-3.857 3.75m11.571-15h-6.428v-2.5h6.428z"
})));
export default SvgYoutubeMobileShortSound;